import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { AiOutlineFile } from "react-icons/ai";
import { Grid, GridColumn, GridToolbar } from "@progress/kendo-react-grid";
import ViewPostingDetails from "../Postings/PostingDetails";
import * as api from "../../api/index.js";
import { handleApiError } from "Helper/index.js";
import { toast } from "react-toastify";
import { Checkbox } from "@progress/kendo-react-inputs";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { filterBy } from "@progress/kendo-data-query";
import {
  DateFormatCell,
  AmountFormatCell,
  CreditAmountFormatCell,
  DebitAmountFormatCell,
  formatDateForAPI,
} from "components/common/formatter";
import {
  printIcon,
  arrowRotateCwIcon as refreshIcon,
} from "@progress/kendo-svg-icons";
import previousIcon from "assets/previous-icon.png";
import { Button } from "@progress/kendo-react-buttons";
import SupplierBalances from "./SupplierBalances";
import DocumentViewer from "components/common/DocumentViewer";
import InfoBox from "components/Global/InfoBox";
import styles from "./Supplier.module.scss";
import { RedirectCell, GRID_PAGE_SIZES } from "components/common/GridComponents";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import {
  fetchConsultantRefs,
  fetchSupplierBalances,
  fetchSuppliersData,
} from "services/supplierService";
import { getSupplierPostings } from "services/postingTypesService";
import { useSearchParams } from "react-router-dom";
import LoadingScreen from "components/common/Loading";
import { useCompany } from "services/companyService";
import { Loader } from "@progress/kendo-react-indicators";
import ReportViewer from "pages/Reports/ReportViewerComponent";
import ExportIcon from "assets/fileIcons/Excel.svg";
import { Icon, SvgIcon } from "@progress/kendo-react-common";
import { exportData } from "components/Report/exportUtility";
import { DateRange } from "components/common/DateRange";
import PreviousTransactionsDialog from "components/common/PreviousTransactions/PreviousTransactions";
import DocumentIconCounter from "components/common/DocumentIconCounter.jsx";

const SupplierLedger = ({ type }) => {
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(false);
  const [searchValue, setSearchValue] = useState();
  const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [isSearched, setIsSearched] = useState(false);
  const [supplierBalances, setSupplierBalances] = useState(null);
  const [isRefreshed, setIsRefreshed] = useState(false);
  const [activeSupplierRefList, setActiveSupplierRefList] = useState([]);
  const [currenttransNo, setTransNo] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [fileData, setFileData] = useState([]);
  const [showDV, setShowDV] = useState(false);
  const supplierRefFromQuery = searchParams.get("supplierRef");
  const [list, setLists] = useState({
    data: [],
    total: 0,
  });
  const [showReport, setShowReport] = useState(false);
  const [shouldLoadReport, setShouldLoadReport] = useState(false);
  const [isExporting, setIsExporting] = useState(false);

  useEffect(() => {
    const fetchRefs = async () => {
      try {
        setLoading(false);
        const refs = type
          ? await fetchConsultantRefs()
          : await fetchSuppliersData({ active: true });
        const list = refs.map((item) => ({
          ...item,
          representation: `${item.supplierRef}  -  ${item.supplierName}`,
        }));
        setActiveSupplierRefList(list);
        setSupplierRefData(list.slice());
      } catch (err) {
        toast.error("Failed to fetch supplier refs");
      } finally {
        setLoading(false);
      }
    };
    fetchRefs();
  }, [type]);

  const [IncludeReversals, setIncludeReversals] = useState(false);

  const handleReserved = () => {
    setIsSearched(false);
    setIsRefreshed(false);
    setIncludeReversals(!IncludeReversals);
  };
  const [dataState, setDataState] = useState({
    take: 200,
    skip: 0,
  });

  const { data: company } = useCompany();
  const date = new Date();
  let yearsStartDate = new Date(
    company.yearStartDate === undefined ? date : company.yearStartDate
  );

  const [fromDate, setFromDate] = useState(formatDateForAPI(yearsStartDate));
  const [fromDateSelector, setFromDateSelector] = useState(yearsStartDate);

  const [toDate, setToDate] = useState(formatDateForAPI(date));
  const [toDateSelector, setToDateSelector] = useState(date);

  const [searchSupplierComboRef, setSearchSupplierComboRef] = useState(null);

  const [supplierRefdata, setSupplierRefData] = useState();
  const [show, setShow] = useState(false);
  const [showPrevTrans, setShowPrevTrans] = useState(false);
  const [prevTransactions, setPrevTransactions] = useState([]);

  useEffect(() => {
    if (!supplierRefFromQuery || !activeSupplierRefList.length) return;

    const match = activeSupplierRefList.find(
      (s) => s.supplierRef === supplierRefFromQuery
    );

    if (match) {
      setSearchSupplierComboRef(match);
      setSearchValue(match.supplierRef);
      setIsSearched(true);
    }
  }, [supplierRefFromQuery, activeSupplierRefList.length]);

  const filterData = (filter) => {
    const datas = activeSupplierRefList.slice();
    return filterBy(datas, filter);
  };

  const postingDoc = async (transNo) => {
    setShow(!show);
    try {
      const { data } = await api.getPostingDocuments(transNo);
      setFileData(data.data);
      setShowDV(true);
    } catch (error) {
      handleApiError(error);
    }
  };

  const onFilterChange = (event) => {
    setSupplierRefData(filterData(event.filter));
  };

  const changeSupplierRef = (event) => {
    const newRef = event.value?.supplierRef || "";
    setSearchSupplierComboRef(event.value);
    setSearchValue(newRef);
    setIsSearched(true);

    setSearchParams({ supplierRef: newRef });
  };
  const loadPostings = async () => {
    if (!fromDate || !toDate || !searchValue) return;

    const page = Math.floor(dataState.skip / dataState.take) + 1;

    try {
      setLoading(true);
      const res = await getSupplierPostings(
        page,
        dataState.take,
        searchValue,
        IncludeReversals,
        fromDate,
        toDate,
        type
      );

      const result = res.data?.data || [];
      setLists({
        data: result,
        total: res.data?.total || result.length,
      });

      const balances = await fetchSupplierBalances(
        searchValue,
        fromDate,
        toDate
      );
      setSupplierBalances(balances);
    } catch (err) {
      handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadPostings();
  }, [searchValue, fromDate, toDate, dataState, IncludeReversals, type]);

  const handleAction = (transNo) => {
    setVisible(!visible);
    setTransNo(transNo);
    setShowForm(true);
  };
  const handleActionRef = (e, transNo) => {
    if (!transNo) return toast("Transcation No is required");
    setTransNo(transNo);
    setVisible(!visible);
    setShowForm(true);
  };

  const Redirect = (props) => (
    <RedirectCell
      handleClick={() => handleAction(props.dataItem.transactionNo)}
    />
  );

  const RefCell = (e) => {
    return (
      <td
        style={{ cursor: e.isPrevTrans ? "default" : "pointer" }}
        onClick={(event) => {
          handleActionRef(event, e.dataItem.transactionNo);
        }}
      >
        <u>{e.dataItem.reference}</u>
      </td>
    );
  };

  const refreshData = async () => {
    setIsSearched(true);
    setIsRefreshed(true);
    await loadPostings(); // just reuse the logic now
  };

  const DocumentCounterCell = (e) => {
    return (
      <td>
        <DocumentIconCounter
          count={e.dataItem.documentCount}
          onClick={() => postingDoc(e.dataItem.transactionNo)}
        />
      </td>
    );
  };

  const handleExportMain = async (config, getRequestBodyArgs, fileName) => {
    setIsExporting(true);
    try {
      await exportData({
        ...config,
        requestBody: config.getRequestBody(...getRequestBodyArgs),
        fileName,
        onStart: () => setIsExporting(true),
        onComplete: () => setIsExporting(false),
        onError: () => setIsExporting(false),
      });
    } catch (e) {
      setIsExporting(false);
    }
  };
  const handleShowPrevTrans = () => {
    if (searchSupplierComboRef) {
      setShowPrevTrans(true);
    }
  };

  const renderMainGrid = () => (
    <div className="flex-grow-1 overflow-auto pr mt-3">
      <Grid
        data={list.data}
        pageable={{
          buttonCount: 5,
          pageSizes: GRID_PAGE_SIZES,
          previousNext: true,
        }}
        skip={dataState.skip}
        take={dataState.take}
        onDataStateChange={(e) => setDataState(e.dataState)}
        className="h-100 grid-minwidth-col4-200"
      >
        <GridToolbar>
          <button
            className={`${styles["dark-background"]} border-0`}
            onClick={() => {
              setShowReport(true);
              setShouldLoadReport(true);
            }}
            title="Print"
            disabled={!searchSupplierComboRef}
          >
            <SvgIcon icon={printIcon} size="default" color="blue" />
          </button>
          <button
            className="btn p-0 d-flex align-items-center justify-content-center border-0"
            onClick={handleExportMain}
            disabled={!searchSupplierComboRef || isExporting}
            title="Export to Excel"
          >
            <div className={styles["dark-background"]}>
              {isExporting ? (
                <Loader
                  size="small"
                  type="infinite-spinner"
                  className="text-dark"
                />
              ) : (
                <img
                  src={ExportIcon}
                  width={18}
                  height={18}
                  alt="Export to Excel"
                />
              )}
            </div>
          </button>
          <button
            className="btn p-0 d-flex align-items-center justify-content-center border-0"
            onClick={handleShowPrevTrans}
            disabled={!searchSupplierComboRef}
            title="Previous Transactions"
          >
            <div className={styles["dark-background"]}>
              <img src={previousIcon} width={15} height={15} alt="previous" />
            </div>
          </button>
        </GridToolbar>
        <GridColumn
          field="date"
          title="Date"
          width="120px"
          cell={DateFormatCell}
        />
        <GridColumn field="postingType" title="Type" width="80px" />
        <GridColumn
          field="reference"
          title="Ref"
          cell={(props) => RefCell({ ...props })}
          width="100px"
        />
        <GridColumn field="details" title="Details" />
        <GridColumn field="transactionPeriod" title="Period" width="80px" />
        <GridColumn
          field="vatAmount"
          title="VAT"
          cell={AmountFormatCell}
          width="100px"
          headerClassName="grid-header-center"
        />

        <GridColumn
          field="grossAmount"
          title="Credit"
          className="creditCol"
          cell={CreditAmountFormatCell}
          width="120px"
          headerClassName="grid-header-center"
        />
        <GridColumn
          field="grossAmount"
          title="Debit"
          className="debitCol"
          cell={DebitAmountFormatCell}
          width="120px"
          headerClassName="grid-header-center"
        />
        <GridColumn
          field="balance"
          title="Balance"
          className="balanceCol balanceTd"
          cell={AmountFormatCell}
          width="140px"
          headerClassName="grid-header-center"
        />
        <GridColumn
          field="documentCount"
          title="Doc"
          width="60px"
          cell={DocumentCounterCell}
          headerClassName="grid-header-center"
        />
        {<GridColumn width="50px" cell={Redirect} />}
      </Grid>
    </div>
  );

  return (
    <div className="page h-100 d-flex flex-column">
      {loading && <LoadingScreen />}
      {showDV && (
        <DocumentViewer data={fileData} onClose={() => setShowDV(false)} />
      )}

      <div
        className={`d-flex flex-wrap align-items-start justify-content-between gap-3 w-100`}
      >
        <div>
          <div className="d-flex flex-wrap align-items-start">
            <span className="mt-2 me-3">
              {type ? "Consultant Ref" : "Supplier Ref"}
            </span>

            <div className="ms-0">
              <ComboBox
                style={{ width: "300px" }}
                data={supplierRefdata}
                textField={"representation"}
                filterable={true}
                onFilterChange={onFilterChange}
                iconClassName="wa"
                placeholder={
                  type ? "Search Consultant Ref" : "Search Supplier Ref"
                }
                value={searchSupplierComboRef}
                onChange={changeSupplierRef}
              />
              <div style={{ height: "10px" }}>
                <InfoBox
                  className="mt-2 w-100"
                  text={
                    searchSupplierComboRef &&
                    `${searchSupplierComboRef?.payeeName || ""}`
                  }
                  title="Payee "
                />
              </div>
            </div>

            <div className="ms-3">
              <Button
                className="common-btn"
                svgIcon={refreshIcon}
                onClick={refreshData}
              >
                Refresh
              </Button>
            </div>
          </div>
          <div className={`d-flex flex-wrap gap-5 align-items-end mt-4`}>
            <DateRange
              fromDate={fromDateSelector}
              toDate={toDateSelector}
              onDateChange={(newFromDate, newToDate) => {
                setFromDateSelector(newFromDate);
                setFromDate(newFromDate ? formatDateForAPI(newFromDate) : null);

                setToDateSelector(newToDate);
                setToDate(newToDate ? formatDateForAPI(newToDate) : null);

                setIsSearched(false);
                setIsRefreshed(false);
              }}
              yearStartDate={company?.yearStartDate}
            />

            <div className="d-flex align-items-center mb-2">
              <Checkbox
                checked={IncludeReversals}
                onChange={handleReserved}
                label="Show Reversed"
              />
            </div>
          </div>
        </div>

        <div className="float-end align-items-end mt-2 mt-lg-0">
          <SupplierBalances
            type="SupplierLedger"
            supplier={searchSupplierComboRef}
            balances={supplierBalances}
          />
        </div>
      </div>

      {showForm && (
        <ViewPostingDetails
          reloadData={refreshData}
          transNo={currenttransNo}
          openingFrom="SupplierLedger"
          cancelEdit={() => {
            setShowForm(false);
          }}
        />
      )}
      {renderMainGrid()}

      {showPrevTrans && (
        <PreviousTransactionsDialog
          isOpen={showPrevTrans}
          onClose={() => setShowPrevTrans(false)}
          entity={searchSupplierComboRef}
          entityType="supplier"
          exportIcon={ExportIcon}
        />
      )}

      {showReport && (
        <Dialog
          title="Supplier Ledger Report"
          onClose={() => setShowReport(false)}
          className="dialog-xxl dialog-title-md"
        >
          <ReportViewer
            name="SupplierLedger.trdp"
            shouldLoad={shouldLoadReport}
            setShouldLoad={setShouldLoadReport}
            parameters={{
              FromDate: fromDate,
              ToDate: toDate,
              SupplierRef: searchSupplierComboRef?.supplierRef,
              IncludeReversals: IncludeReversals,
            }}
          />
          <DialogActionsBar>
            <div className="dialog-footer d-flex justify-content-end">
              <button
                className="common-btn me-5"
                onClick={() => setShowReport(false)}
              >
                Close
              </button>
            </div>
          </DialogActionsBar>
        </Dialog>
      )}
    </div>
  );
};

export default SupplierLedger;
